<template>
    <ContentCard theme="brown" icon="assets/images/illu-tree.svg">
        <template #title>How many arms does a<br> tree have?</template>
        <template #description>Trees are beautiful - join Dani and start singing their song!
        </template>
        <template #buttons>
            <ButtonPill icon="play" class="card__btn me-8"
                        @click.native="$store.commit('SET_LIGHTBOX', 'X7ONDecOEhw')">Watch Now
            </ButtonPill>
            <ButtonPill href="/pdfs/Tree-Song.pdf" target="_blank" icon="file" class="card__btn"
                        orange>ACTIVITY
            </ButtonPill>
        </template>
    </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard';
import ButtonPill from '@/components/ButtonPill';
export default {
    components: {ButtonPill, ContentCard}
};
</script>
